import { Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ScheduleSlot } from '../../../interfaces/schedule';

@Component({
  selector: 'app-schedule-col',
  templateUrl: './schedule-col.component.html',
  styleUrls: ['./schedule-col.component.scss']
})
export class ScheduleColComponent {
  @HostBinding('class') get class() {
    return 'col day-col';
  };
  @HostBinding('class.active-col') @Input() active: boolean = false;
  @Input() onlineClassText!: any;
  @Input() cancelledClassText!: any;
  @Input() hibridClassText!: any;
  @Input({ required: true }) timeRange!: number[];
  @Input({ required: true }) data!: any;
  @Input() homeMode: boolean = false;
  @Input({ required: true }) noResultsTitle!: string;
  @Input() noResultsContent!: string;
  @Input() noResultsLink!: string | null;
  @Input() noResultsLinkText!: string | null;
  @Input() isLoading: boolean = false;
  @Input() showFullNoResult: boolean = true;
  @Input() notificationsHeaderText: string = "";
  slots!: ScheduleSlot[];
  slotPosition: number = 0;
}
